<template>
  <treeselect
    v-if="positions"
    ref="treeselect"
    v-model="internalValue"
    :disabled="deactivated"
    :options="selectableCountries"
    :show-count="true"
    showCountOf="LEAF_DESCENDANTS"
    :placeholder="placeholder"
    :disable-branch-nodes="true"
    :flatten-search-results="true"
    value-consists-of="LEAF_PRIORITY"
  >
  </treeselect>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";

import { mapGetters } from "vuex";

export default {
  components: { Treeselect },
  props: {
    value: {
      Type: Object | Array | null,
      default: null,
    },
    placeholder: {
      Type: String | undefined,
      default: "Select a position",
    },
    deactivated: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["onPositionSelected"],
  computed: {
    ...mapGetters({
      positions: "userQueries/positions",
    }),
    internalValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
        if (!v) return this.$emit("onPositionSelected", null);
        this.$emit("onPositionSelected", v);
      },
    },
    selectableCountries() {
      return this.positions.map((positionInfo) => {
        return { id: positionInfo.id, label: positionInfo.name };
      });
    },
  },
};
</script>

<style lang="scss">
.vue-treeselect__multi-value {
  max-height: 180px;
  overflow-y: auto;
}
</style>